export default __webpack_public_path__ + "static/media/smiling-woman.e4584a13.png";